document.addEventListener("DOMContentLoaded", function () {
  const durationTime = document.querySelector(".hero-with-sliders__body-narrow-slider [data-duration]").dataset.duration * 1000;

  new Swiper(".narrowSlider", {
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: durationTime,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  new Swiper(".wideSlider", {
    spaceBetween: 20,
    navigation: {
      nextEl: ".wide-slider__button-next",
      prevEl: ".wide-slider__button-prev",
    },
  });
});
